import { render, staticRenderFns } from "./appUniversal.vue?vue&type=template&id=c9a4c79a&scoped=true"
import script from "./appUniversal.vue?vue&type=script&lang=js"
export * from "./appUniversal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a4c79a",
  null
  
)

export default component.exports